module.exports = __webpack_public_path__ + "static/media/icon_blue.e57ed911.svg";